import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { stocksClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { cleanRequest } from './cleanRequest'

const MUTATION = gql`
  mutation UpsertStockItem($input: StockItemInput) {
    upsertStockItem(input: $input) {
      id
    }
  }
`

const hasDuplicates = emails => {
  if (!emails) return false
  const trimmed = emails.map(e => e.trim()).filter(Boolean)
  const unique = new Set(trimmed)
  return unique.size !== trimmed.length
}

const validate = (form, setErrors, t) => {
  const notificationEmails = form?.notificationEmails
    ?.split(';')
    ?.map(e => e.trim())
    ?.filter(Boolean)
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: t('validation.required') }),
    ...appendIf(!form.amount, { path: ['amount'], message: t('validation.required') }),
    ...appendIf(form.amount && form.amount <= 0, {
      path: ['amount'],
      message: t('validation.amountGreaterThanZero')
    }),
    ...appendIf(
      notificationEmails &&
        !notificationEmails?.every(email => /^[\w.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.trim())),
      {
        path: ['notificationEmails'],
        message: t('validation.invalidEmails')
      }
    ),
    ...appendIf(hasDuplicates(notificationEmails), {
      path: ['notificationEmails'],
      message: t('validation.duplicateEmails')
    })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveStocks = () => {
  const { t } = useTranslation('editStocks')
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['StockItems'],
    client: stocksClient
  })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)

    const { setErrors } = actions
    const isValid = validate(form, setErrors, t)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
